module.exports = __webpack_public_path__ + "img/log-mobilogo.17d2dafe.png";